import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import BlogPost from "@/pages/BlogPost";

export const Route = createFileRoute("/es/blog/$slug")({
  loader: ({ params }) => loadContentMeta("blog_posts", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/blog/${params.slug}`, loaderData, params.slug === "eudravigilance-gestion-senales-enfoques" ? {
      title: "Gestión de Señales con EudraVigilance: Elige tu Enfoque | QbD Group",
      description: "Explora tres formas de integrar los datos de EudraVigilance en la gestión de señales, desde la validación y evaluación hasta la detección y el seguimiento basados en el riesgo.",
    } : {}),
  component: BlogPost,
});

